import { Link } from 'react-router-dom';

export default function StatsBanner() {
  return (
    <section className="py-12 md:py-16 bg-accent-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-2">
          为什么选择土豪漫画？
        </h2>
        <p className="text-sm text-background-50/80 mb-10 max-w-2xl mx-auto">
          我们致力于为广大漫画爱好者提供最优质的免费在线阅读体验
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { icon: 'ri-book-open-line', value: '30,000+', label: '漫画资源' },
            { icon: 'ri-group-line', value: '500,000+', label: '日活跃用户' },
            { icon: 'ri-smartphone-line', value: '全终端', label: '随时随地阅读' },
            { icon: 'ri-shield-check-line', value: '全免费', label: '无限制畅读' },
          ].map((stat) => (
            <div key={stat.label} className="flex flex-col items-center">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/20 flex items-center justify-center mb-3">
                <i className={`${stat.icon} text-background-50 text-xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading text-background-50">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-50/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>

        <Link
          to="/category/all"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="inline-flex items-center gap-2 mt-10 px-8 py-3 rounded-full bg-background-50 text-accent-600 text-sm font-medium hover:bg-background-50/90 transition-colors whitespace-nowrap"
        >
          <i className="ri-book-read-line"></i>
          立即开始免费阅读
        </Link>
      </div>
    </section>
  );
}